import React, { useState, useEffect } from 'react';
import {bool, func, string} from 'prop-types';

import {makeStyles} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  paper: {
    padding: '10px'
  }
}))

const useLoadingStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    right: '39px'
  }
}));

export default function ConfirmDialog({active, message, onClose, onConfirm}) {
  const classes = useStyles();
  const loadingClasses = useLoadingStyles();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, [active]);

  function handleConfirm() {
    setLoading(true);
    onConfirm();
  }

  return (
    <Dialog
      open={active}
      onClose={onClose}
      classes={{
        paper: classes.paper
      }}
    >
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} disabled={loading}>
          No
        </Button>
        <Button variant="contained" onClick={handleConfirm} color="primary" autoFocus disabled={loading}>
          Yes
        </Button>
        {loading && <CircularProgress size={24} className={loadingClasses.root} />}
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  active: bool,
  message: string,
  onClose: func,
  onConfirm: func
}
